module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_rili2.2975b.png";